import React from 'react'
import { useMutation, useQueryClient } from 'react-query'
import { useToast } from '@chakra-ui/react'
import { getAppConfigSetting } from '../utils'
import { SENTINEL_API } from './constants'
import queryKeys from './queryKeys'
import axios, { AxiosError } from 'axios'
import { delayFn } from '../utils'
import { Alert, useAlert } from '@apex/component-library'
// TODO: Replace with ui-components toast

const postPositionJournalURL = `${getAppConfigSetting('apiUrl')}${SENTINEL_API}/journals/position`

export const postPositionJournalSubmission = async (payload: {}) => {
  const { data } = await axios.post(postPositionJournalURL, payload, {
    withCredentials: true
  })
  return data
}

interface Options {
  onMutate?: Function
  onError?: Function
  onSuccess?: Function
  onSettled?: Function
}

export function useCreatePositionJournal(options?: Options) {
  const { onMutate, onError, onSuccess, onSettled } = options || {}
  const queryClient = useQueryClient()
  const toast = useToast()
  const { setAlert } = useAlert()
  return useMutation(postPositionJournalSubmission, {
    onMutate: (variables) => {
      // Do stuff before post call
      onMutate && onMutate()
    },
    onError: (error: AxiosError, variables, context) => {
      if (error.response?.status && error.response.status >= 400 && error.response.status < 500) {
        toast({
          position: 'top-right',
          variant: 'left-accent',
          isClosable: true,
          title: 'The request failed.',
          description: `${error.response.data.errorDescription}`,
          status: 'error',
          duration: null,
          render: ({ onClose, id }) => (
            <Alert
              sx={{
                width: 340,
                color: 'black',
                bg: 'white',
                boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
              }}
              direction='column'
              variant='left-accent'
              title='The request failed.'
              description={`${error?.response?.data?.errorDescription}`}
              status='error'
              isClosable
              dismiss={onClose}
              id={id as string}
            />
          )
        })
      } else {
        setAlert({
          direction: 'row',
          variant: 'left-accent',
          title: 'System Unavailable',
          description: 'Sorry, this service is temporarily unavailable. The request failed.',
          status: 'error',
          isClosable: true
        })
      }
      onError && onError()
    },
    onSuccess: () => {
      // Invalidate query after 5 seconds.
      delayFn(() => queryClient.invalidateQueries(queryKeys.positionJournalTransfers), 5000)
      toast({
        duration: 8000,
        position: 'top-right',
        variant: 'left-accent',
        status: 'success',
        isClosable: true,
        render: ({ onClose, id }) => (
          <Alert
            sx={{
              width: 340,
              color: 'black',
              bg: 'white',
              boxShadow: '0px 0px 5px 3px rgba(153,153,153,0.5)'
            }}
            direction='column'
            variant='left-accent'
            title='Success!'
            description='Your transfer request is scheduled for processing.'
            status='success'
            isClosable
            dismiss={onClose}
            id={id as string}
          />
        )
      })
      onSuccess && onSuccess()
    },
    onSettled: (data, error, variables, context) => {
      // do stuff after Error or success.
      onSettled && onSettled()
    }
  })
}
